import { stepOverseasMedicalExpenseLookup as expenseLookup } from './claimCodeMapper';
import { mapToMedicalExpense, mapToAccidentalDeathExpense, mapToLossOfIncomeExpense } from './expenseMapper';
import { convertDateForMappingQuestion, convertTimeForMappingQuestion } from '../../../utils/dateUtil';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section7.areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses',
      answer: data.areYouClaimingForEmergencyMedicalAndHospitalExpenses,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.areYouClaimingForAccidentalDeath',
      answer: data.areYouClaimingForAccidentalDeath,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.areYouClaimingForLossOfIncome',
      answer: data.areYouClaimingForLossOfIncome,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.patientName',
      answer: data.patientName,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.relationshipToYou',
      answer: data.relationshipToYou,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.patientDateOfBirth',
      answer: data.patientDateOfBirth,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.medicareNumber',
      answer: data.medicareNumber,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.whatIsYourInjuryOrIllness',
      answer: data.whatIsYourInjuryOrIllness,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.didThisOccurWhilstEngagingInSnowSportActivity',
      answer: data.didThisOccurWhilstEngagingInSnowSportActivity,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.wasTheInufredIllTravallerAnInpatient',
      answer: data.wasTheInufredIllTravallerAnInpatient,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.dateOfAdmission',
      answer: convertDateForMappingQuestion(data.dateOfAdmission),
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.timeOfAdmission',
      answer: convertTimeForMappingQuestion(data.timeOfAdmission),
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.dateOfDischarge',
      answer: convertDateForMappingQuestion(data.dateOfDischarge),
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.timeOfDischarge',
      answer: convertTimeForMappingQuestion(data.timeOfDischarge),
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.nameOfPractitionerDentistHospital',
      answer: data.nameOfPractitionerDentistHospital,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.contactEmergencyAssistance',
      answer: data.contactEmergencyAssistance,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.assistanceCaseReferenceNumber',
      answer: data.assistanceCaseReferenceNumber,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.dateOfFirstMedicalConsultation',
      answer: data.dateOfFirstMedicalConsultation,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.hasInjuredOrIllTravellerPreviously',
      answer: data.hasInjuredOrIllTravellerPreviously,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.awareOfAnyMedicalConditions',
      answer: data.awareOfAnyMedicalConditions,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.underInvestigation',
      answer: data.underInvestigation,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.haveMedicalConditionOrComplication',
      answer: data.haveMedicalConditionOrComplication,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.giveATerminalPrognosis',
      answer: data.giveATerminalPrognosis,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.travellingAgainst',
      answer: data.travellingAgainst,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.previousMedicalConditionDetails',
      answer: data.previousMedicalConditionDetails,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.actualReturnToWorkDate',
      answer: data.actualReturnToWorkDate,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.insuredName',
      answer: data.insuredName,
      claimTypeCode: claimCode,
    },
    {
      question: 'section7.insuredDateOfDeath',
      answer: data.insuredDateOfDeath,
      claimTypeCode: claimCode,
    },
  ];
}

// function getExpenseClaimCode(data) {
//   if (data.areYouClaimingForEmergencyMedicalAndHospitalExpenses === 'true') {
//     return expenseLookup.areYouClaimingForEmergencyMedicalAndHospitalExpenses;
//   }
//   if (data.areYouClaimingForAccidentalDeath === 'true') {
//     return expenseLookup.areYouClaimingForAccidentalDeath;
//   }
//   if (data.areYouClaimingForLossOfIncome === 'true') {
//     return expenseLookup.areYouClaimingForLossOfIncome;
//   }
//   return emptyClaimCode;
// }

function mapToExpenses(data) {
  // const claimCode = getExpenseClaimCode(data);
  const medicalExpenses = (data.areYouClaimingForEmergencyMedicalAndHospitalExpenses === 'true') ? data.medicalExpenses.map(mapToMedicalExpense, expenseLookup.areYouClaimingForEmergencyMedicalAndHospitalExpenses) : [];
  const accidentalDeathExpense = (data.areYouClaimingForAccidentalDeath === 'true') ? mapToAccidentalDeathExpense(data, expenseLookup.areYouClaimingForAccidentalDeath) : [];
  const lossIncomeExpense = (data.areYouClaimingForLossOfIncome === 'true') ? mapToLossOfIncomeExpense(data, expenseLookup.areYouClaimingForLossOfIncome) : [];
  return [...medicalExpenses, ...accidentalDeathExpense, ...lossIncomeExpense];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepOverseasMedicalDataMapper.js